//////LIBRARY//////
import React, { Fragment, useEffect, useState, useMemo } from 'react'
import { cloneDeep, isEmpty, isEqual, reduce, find, isUndefined, isNull } from 'lodash'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom'
//////COMPONENTS//////
import Table from '../../components/Table'
import ActionsTable from '../../components/ActionsTable'
import Theme from '../../theme/theme'
import { initKioskCreationAddPricesActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import ToggleFilters from '../../components/Ui/ToggleFilters'
import Button from '../../components/Ui/Buttons'
import { uriList } from '../../routings/settings/RouteList'
import PriceFormatter from '../../helpers/PriceFormatter'
import ValueCheck from '../../helpers/ValueCheck'
import { PageWrapperLinks } from '../../theme/GlobalCss'
import TooltipHelp from '../../components/TooltipHelp'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import ArrowWhiteRight from '../../assets/icones/global/arrow-white-right.svg'
import ErrorSign from '../../assets/icones/global/warning-red.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const InputErrorTableWrapper = styled.div`
	display: grid;
	grid-template-columns: ${(props) => (props.errors ? 'max-content 2fr' : '1fr')};
	justify-content: center;
	align-items: center;
	grid-column-gap: 10px;
	width: max-content;
	margin: auto;
`
const InputTableRow = styled.input`
	width: 80px;
	padding: 5px;
	text-align: center;
`
const ErrorInputTable = styled.img`
	max-height: 32px;
`
const PageWrapperLinksCustom = styled(PageWrapperLinks)`
	top: ${(props) => (props.rafterDisplayed ? '-130px' : '-90px')};
`
//////STYLED//////

const KioskAddPrices = (props) => {
	const { translations } = props

	let history = useHistory()
	const location = useLocation()
	// region USE STATE ....
	const [paging, setPaging] = useState({ page: '0', size: '250' })
	const [prevFilter, setPrevFilter] = useState({})
	const [columns, setColumns] = useState([])
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)
	const [errors, setErrors] = useState(null)
	const [isEditable, setIsEditable] = useState(false)

	const match = useRouteMatch()

	// search bar
	const [searchValue, setSearchValue] = useState()

	// inline edit object editKey id object UNIQ and edit key is mapper to editKey in row selected ( example in /RecapStock/ActionsTable )
	const [inLineEdit, setInlineEdit] = useState({
		editId: null,
		editKey: '',
	})
	//region USE SELECTOR
	const {
		user,
		userRolePrivileges,
		initKioskCreationStatus,
		initKioskCreation,
		addPrices,
		addPricesContent,
		addPricesContentFilters,
		isSearchfieldUpdated,
	} = useSelector(
		(state) => ({
			user: state.user,
			userRolePrivileges: state.user.identity.rolePrivileges,
			initKioskCreation: state.initKioskCreation,
			addPrices: state.initKioskCreation.addPrices,
			addPricesContent: state?.initKioskCreation?.addPrices?.data?.headerContent?.contentPagined?.content,
			addPricesContentFilters: state.initKioskCreation.addPrices.data?.headerParam?.filters,
			initKioskCreationStatus: state.initKioskCreation?.addPrices?.data?.headerParam?.progressInfo?.statusId,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
		}),
		shallowEqual
	)
	// endregion

	const kioskAddPricesActions = bindActionCreators(initKioskCreationAddPricesActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {},
		paging: {
			fnSendTo: (paging) => handlePagingRecap(paging),
		},
	})
	const [configTable, setConfigTable] = useState({
		isKioskAddPrices: true,
	})
	//endregion

	///////////////////////////////////////////////////////////// HANDLER////////////////////////////////////////////////////////

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handlePagingRecap = (paging) => {
		setPaging(paging)
		kioskAddPricesActions.postKioskAddPrices(handleFilterSend(), parseInt(match.params.id), paging)
	}

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change

		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		kioskAddPricesActions.postKioskAddPrices(handleFilterSend(), parseInt(match.params.id), paging)
	}

	const handleWithTTC = () => {
		let filtersCP = cloneDeep(filters)

		filtersCP.pricesTTC = !filtersCP.pricesTTC

		setFilters(filtersCP)
		const str_filters = handleFilterSend()
		// Even if we set our hook, in HandleFilterSend,
		// TTC value is not actualised,
		// So we reset value here...
		str_filters.pricesTTC = filtersCP.pricesTTC
		str_filters.searchField = searchValue

		kioskAddPricesActions.postKioskAddPrices(str_filters, parseInt(match.params.id), paging)
	}

	const handlePutSubmit = (data, _selectedData) => {
		let filtersCP = cloneDeep(filters)
		kioskAddPricesActions.putUpdatePrices(
			reduce(
				data,
				(result, value, key) => {
					if (!value.itemPrice || key === 'null') return result
					result.push({
						id: key,
						standardPrice: value.itemPrice,
						depositPrice: value.depositPrice || 0,
					})

					return result
				},
				[]
			),
			match.params.id,
			filtersCP.pricesTTC
		)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			...filtersOut,
			withFilters: true,
		}
	}

	const handleFollowingStep = () => {
		const pathName = location.pathname
		//actionsImplantation.putValidateImplantation(match.params.id, redirectTest)
		kioskAddPricesActions.putValidatePrices(match.params.id, pathName.indexOf(uriList.initKioskCustomerManager) === -1 ? '' : 'customer')
	}

	const handleRedirect = () => {
		if (!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[32]))) {
			history.push(`${uriList.initKiosks}${uriList.initKioskBusinessManager}`)
		} else if (!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[33]))) {
			history.push(`${uriList.initKiosks}${uriList.initKioskCustomerManager}`)
		}
	}
	///////////////////////////////////////////////////////////// USE EFFECT //////////////////////////////////////////////////////

	useEffect(() => {
		return function cleanUp() {
			kioskAddPricesActions.resetDataAddPrices()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		const userCp = cloneDeep(user)
		const isPriceTTC = userCp.identity.isPricesTTC
		if (isUndefined(user) || isEmpty(translations)) return
		if (isEmpty(filters)) {
			const filtersCp = {
				searchField: null,
				withFilters: false,
				pricesTTC: isPriceTTC,
				searchFieldUpdated: false,
			}

			kioskAddPricesActions.postKioskAddPrices(filtersCp, parseInt(match.params.id))
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}

		// Disable fields if we are coming from "View" action, or by charging request with URL address
		if (!isUndefined(addPrices.data?.headerParam)) {
			let editable = true
			if (initKioskCreation.forceReadOnly) {
				editable = false
			} else {
				editable = addPrices.data?.headerParam?.progressInfo.editable
			}
			setIsEditable(editable)
		}
	}, [addPrices, translations])
	useEffect(() => {
		if (!isUndefined(addPricesContentFilters)) {
			const filtersCp = cloneDeep(addPricesContentFilters)
			setFilters(filtersCp)
			setPrevFilter(filtersCp)
			filtersCp.withFilters = true
			filtersCp.searchField = null
		}
	}, [addPricesContentFilters])

	useEffect(() => {
		if (isUndefined(searchValue)) return
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue) return

		handleSubmit()
	}, [filters.searchField])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions = {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				defaultValue: searchValue,
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)

		cfgCp.massEdit = initKioskCreationStatus < 13
		cfgCp.actions = {
			// edit attribute can have declared two methods :
			// - validate triggered on handleOnSubmit method of Table component
			// - cancel is passed as fn argument on handleCloseForm method of Table component
			edit: {
				validate: (data, selectedData) => {
					handlePutSubmit(data, selectedData)
				},
				inlineEdit: inLineEdit,
				setInlineEdit: setInlineEdit,
			},
		}

		setConfigTable(cfgCp)
	}, [initKioskCreationStatus, translations, filters, prevFilter, inLineEdit])

	useEffect(() => {
		setConfigTableTitle({
			name: translations['page__initKiosk__kioskCreation_prices_title'],
			isKioskAddPrices: true,
			paging: {
				totalElements: addPrices.data?.headerContent?.contentPagined?.totalElements,
				totalPages: addPrices.data?.headerContent?.contentPagined?.totalPages,
				fnSendTo: (paging) => handlePagingRecap(paging),
			},
			usingRafters: true,
			actions: {
				toggleLists: [
					() => (
						<TooltipHelp content={'tooltipHelp__admin__modal__body__table__filter__vatSwitch'} childrenPos={2}>
							<ToggleFilters
								checked={filters?.pricesTTC}
								onChangeHandler={handleWithTTC}
								size={'large'}
								name="withTTC"
								labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
								labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
							/>
						</TooltipHelp>
					),
				],
				searchBarComponent: {
					handleSearchEnter: handleSearchEnter,
					handleClickSearch: handleClickSearch,
					placeholder: translations['common__text__fastFilter_search'],
					handleReset: (refInput) => {
						refInput.current.value = ''
						setSearchValue('')
					},
				},
				followingStep: {
					id: 'continue',
					type: 'submit',
					imgLeftMgin: '11px',
					imgMgin: '11px',
					img: ArrowWhiteRight,
					bgColor: Theme.colors.validation,
					height: 32,
					width: 208,
					text: translations['page__initKiosk__common__action_nextStep'],
					actionHandler: handleFollowingStep,
					step: true,
					disabled: !isEditable,
				},

				rest: [
					() => (
						<DropdownCheckbox
							title={translations['page__initKiosk__kioskCreation_prices_filters_brand']}
							data={filters?.filtersSelection?.brands?.filterElements || []}
							translations={translations}
							paperTopPosition={'40'}
							dropColor={'blueColor'}
							selectActionsHandler={handleCheckElements}
							submitOnClose={handleSubmit}
							target={'brands'}
						/>
					),
					() => (
						<DropdownCheckbox
							title={translations['page__initKiosk__kioskCreation_prices_filters_familly']}
							data={filters?.filtersSelection?.famillies?.filterElements || []}
							translations={translations}
							paperTopPosition={'40'}
							toTranslate
							dropColor={'blueColor'}
							selectActionsHandler={handleCheckElements}
							submitOnClose={handleSubmit}
							target={'famillies'}
						/>
					),
				],
			},
		})
	}, [translations, filters, prevFilter, inLineEdit, initKioskCreation])

	useEffect(() => {
		// It seems when we set columns by useEffect,
		// toTranslate and toMapObject cannot work properly (even when we apply tests on it)
		setColumns([
			{
				columnReferential: 'kioskInCreationPrice_family',
				dataHook: 'itemFamily.translationKey',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_familly'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				columnReferential: 'kioskInCreationPrice_brand',
				dataHook: 'itemBrand.label',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_brand'],
				sortable: true,
				isAuthorize: true,
			},
			{
				columnReferential: 'kioskInCreationPrice_type',
				dataHook: 'itemType.translationKey',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_type'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				columnReferential: 'kioskInCreationPrice_itemCode',
				dataHook: 'codeItem',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_codeItem'],
				sortable: true,
				isAuthorize: true,
			},
			{
				columnReferential: 'kioskInCreationPrice_item',
				dataHook: 'itemLabelToDisplay',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_item'],
				sortable: true,
				isAuthorize: true,
			},

			{
				columnReferential: 'kioskInCreationPrice_salePrice',
				dataHook: 'itemPrice',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_standardPrice'],
				sortable: true,
				isAuthorize: true,

				edit: (props) => {
					if (!isUndefined(props.error)) {
						setErrors(props.error)
					}
					return (
						(props.row.standardLine || isUndefined(props.row.standardLine)) && (
							<InputErrorTableWrapper errors={props.error[props.row.id]}>
								{props.error[props.row.id]?.itemPrice && (
									<>
										<ErrorInputTable src={ErrorSign} />
									</>
								)}
								<InputTableRow
									type="number"
									step="any"
									defaultValue={PriceFormatter.stringToNumberInput(props.row.itemPrice)}
									name={`${props.row.id}.itemPrice`}
									ref={props.register({
										min: { value: 0, message: translations['common__message__price_minimum'] },
										max: { value: 9999.999, message: translations['common__message__price_maximum'] },
										required: { value: true, message: translations['common__text__requiredField'] },
										pattern: { value: /^[\d]*[\{.,,}]?\d{0,2}$/, message: '2 chiffres après la virgule au maximum ' },
									})}
								/>
								{}
							</InputErrorTableWrapper>
						)
					)
				},
				component: (props) =>
					!isNull(props.row.itemPrice) && !isUndefined(props.row.itemPrice) ? ` ${props.row.itemPrice} ${props.row.currency?.symbol}` : '-',
			},
			{
				columnReferential: 'kioskInCreationPrice_conversion',
				dataHook: 'conversion',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_conversion'],
				sortable: true,
				isAuthorize: true,
				component: (props) => `${props.row.conversion} ${props.row?.currency?.symbol}`,
			},
			{
				columnReferential: 'kioskInCreationPrice_saleVAT',
				dataHook: 'itemVatRate',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_standardPriceVAT'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.itemVatRate) ? `${props.row.itemVatRate} %` : '-'),
			},
			{
				columnReferential: 'kioskInCreationPrice_consignmentPrice',
				dataHook: 'depositPrice',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_depositPrice'],
				sortable: true,
				isAuthorize: true,

				edit: (props) => {
					return (
						(props.row.standardLine || isUndefined(props.row.standardLine)) && (
							<InputErrorTableWrapper errors={props.error[props.row.id]}>
								{props.error[props.row.id]?.depositPrice && <ErrorInputTable src={ErrorSign} />}
								<InputTableRow
									type="number"
									step="any"
									disabled={props.row.itemType.id === 1}
									defaultValue={PriceFormatter.stringToNumberInput(props.row.depositPrice)}
									//defaultValue={ ValueCheck.ValueCheck(PriceFormatter.stringToNumberInput(props.row.depositPrice)) }
									name={`${props.row.id}.depositPrice`}
									ref={props.register({
										min: { value: 0, message: translations['common__message__price_minimum'] },
										max: { value: 9999.999, message: '9999,999 est le maximum' },
										required: { value: true, message: translations['common__text__requiredField'] },
										pattern: { value: /^[\d]*[\{.,,}]?\d{0,2}$/, message: '2 chiffres après la virgule au maximum ' },
									})}
								/>
								{}
							</InputErrorTableWrapper>
						)
					)
				},
				component: (props) =>
					props.row.depositPrice === '' || isNull(props.row.depositPrice)
						? '- '
						: ` ${props.row.depositPrice} ${props.row.currency.symbol}`,
			},
			{
				columnReferential: 'kioskInCreationPrice_consignmentVAT',
				dataHook: 'depositVatRate',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_depositPriceVAT'],
				sortable: true,
				isAuthorize: true,
				//component: props => (props.row?.depositVatRate !== "" || !isNull(props.row?.depositVatRate)) ? `${props.row?.depositVatRate} %` : '-'
				component: (props) => ValueCheck.ValueCheck(props.row?.depositVatRate, '-', '%'),
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				boolRight: isEditable,
			},
		])
	}, [translations, isEditable, inLineEdit])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 26,
		labelPageTable: 'kioskInCreationPrice',
	}

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={addPricesContent}
				inputConfig={configTable}
				currentPaging={paging}
				tableReferential={tableReferential}
			/>
		)
	}, [initKioskCreation, columns, configTable, translations, paging])
	return (
		<Fragment>
			<UsersManagerWrapper>
				<PageWrapperLinksCustom rafterDisplayed={initKioskCreation.statusId >= 6 ? true : false}>
					<Button goBack weight="bold" actionHandler={() => handleRedirect()} text={translations['common__text__previousPage']} />
				</PageWrapperLinksCustom>

				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} isFollowingStep={true} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

KioskAddPrices.propTypes = {}

KioskAddPrices.defaultPropTypes = {}

export default KioskAddPrices
